module.exports = __webpack_public_path__ + "static/media/wave_pool.f4c97922.jpeg";